// extracted by mini-css-extract-plugin
export default {"chatEmotes":"chat-commands_chatEmotes__x+6lD","chatEmotesAbstract":"chat-commands_chatEmotesAbstract__+peRn","chatEmotesItem":"chat-commands_chatEmotesItem__zJ0j-"};